import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const AvatarHeader = ({ onClose, title, modalRef }) => {
  // ref usado para controlar o ModalGlobal (abrir o modal de loading, etc)

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1380px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "12px",
        borderRadius: "12px",
        color: "#662d91",
        fontSize: "20px",
        fontWeight: "600",
        lineHeight: "30px",
        position: "relative",

        // Responsividade para telas menores
        "@media (max-width: 720px)": {
          fontSize: "16px",
          padding: "8px",
          justifyContent: "center",
          textAlign: "center",
        },
      }}
    >
      <Typography
        sx={{
          display: "flex",
          alignItems: "center",
          marginRight: "30px",
          marginLeft: "28px",
          marginTop: "20px",
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: "26.409px",

          "@media (max-width: 720px)": {
            fontSize: "16px",
            margin: "5px 10px",
            maxWidth: "calc(100% - 50px)",
            textAlign: "center",
          },
        }}
      >
        {title}
      </Typography>
      {/* Botão de fechar o modal */}
      <Box
        sx={{
          position: "absolute",
          top: "25px",
          right: "50px",
          zIndex: 1000,

          "@media (max-width: 720px)": {
            top: "8px",
            right: "8px",
          },
        }}
      >
        <IconButton
          onClick={() => {
            onClose();
            modalRef?.current?.nextModal(0);
          }}
          sx={{ p: 0 }}
        >
          <CancelOutlinedIcon color="primary" sx={{ fontSize: 30 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default AvatarHeader;
